export default "__VITE_ASSET__DeX15yVp__"